import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import BASE_URL from '../config/config';
import { Link, useNavigate } from 'react-router-dom';
import ContentLoader from 'react-content-loader';

const Notificaciones = () => {
  const [notificacionesTickets, setNotificacionesTickets] = useState([]);
  const [notificacionesPersonalizadas, setNotificacionesPersonalizadas] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const dropdownRef = useRef(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const obtenerIconoNotificacion = (tipo, icono) => {
    const iconos = {
      'campana': '/images/notificacion-noti.svg',
      'ticket': '/images/ticket-noti.svg',
      'info': '/images/descubrir.svg',
      'alerta': '/images/reloj.svg',
      'usuario': '/images/servicio-al-cliente.svg'
    };
    return iconos[icono] || iconos['campana'];
  };

  const obtenerClasePrioridad = (prioridad) => {
    const clases = {
      'urgente': 'prioridad-urgente',
      'alta': 'prioridad-alta',
      'normal': 'prioridad-normal',
      'baja': 'prioridad-baja'
    };
    return clases[prioridad] || clases['normal'];
  };

  const obtenerTextoPrioridad = (prioridad) => {
    const textos = {
      'urgente': 'URGENTE',
      'alta': 'ALTA',
      'normal': 'NORMAL',
      'baja': 'BAJA'
    };
    return textos[prioridad] || 'NORMAL';
  };

  const marcarComoLeida = async (id) => {
    try {
      const token = localStorage.getItem("AuthToken");
      await axios.put(`${BASE_URL}/notificaciones/${id}/marcar-leida`, {}, {
        headers: { Authorization: token }
      });
      
      // Remover la notificación de la lista
      setNotificacionesPersonalizadas(prev => 
        prev.filter(notif => notif.id !== id)
      );
    } catch (error) {
      console.error('Error al marcar notificación como leída:', error);
    }
  };

  const manejarClickNotificacion = (notificacion) => {
    marcarComoLeida(notificacion.id);
    setIsDropdownOpen(false);
    
    if (notificacion.link) {
      // Si el link es una ruta interna (empieza con /)
      if (notificacion.link.startsWith('/')) {
        navigate(notificacion.link);
      } else {
        // Si es una URL externa
        window.open(notificacion.link, '_blank');
      }
    }
  };

  const marcarTodasComoLeidas = async () => {
    try {
      const token = localStorage.getItem("AuthToken");
      const decodedToken = jwtDecode(token);
      const { usuario } = decodedToken;
      
      await axios.put(`${BASE_URL}/notificaciones/${usuario}/marcar-todas-leidas`, {}, {
        headers: { Authorization: token }
      });
      
      setNotificacionesPersonalizadas([]);
    } catch (error) {
      console.error('Error al marcar todas como leídas:', error);
    }
  };

  const fetchNotificaciones = async (silent = false) => {
    if (!silent) {
      setIsLoading(true);
    }
    setError(null);
    
    try {
      const token = localStorage.getItem("AuthToken");
      if (!token) {
        throw new Error("Token de autenticación no encontrado.");
      }

      const decodedToken = jwtDecode(token);
      if (!decodedToken || !decodedToken.usuario || !decodedToken.role) {
        throw new Error("El token es inválido o carece de información requerida.");
      }

      const { usuario, role } = decodedToken;

      // Obtener notificaciones de tickets (sistema anterior)
      const responseTickets = await axios.get(`${BASE_URL}/ticket/notificaciones/${usuario}`, {
        params: { role },
      });

      // Obtener notificaciones personalizadas (nuevo sistema)
      const responseNotificaciones = await axios.get(`${BASE_URL}/notificaciones/${usuario}`, {
        headers: { Authorization: token }
      });

      if (responseTickets.status === 200) {
        setNotificacionesTickets(responseTickets.data.tickets || []);
      }

      if (responseNotificaciones.status === 200) {
        setNotificacionesPersonalizadas(responseNotificaciones.data.notificaciones || []);
      }
    } catch (err) {
      console.error('Error al obtener notificaciones:', err);
      setError('Ocurrió un error al cargar las notificaciones.');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    fetchNotificaciones();
    const interval = setInterval(() => {
      fetchNotificaciones(true);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const totalNotificaciones = notificacionesTickets.length + notificacionesPersonalizadas.length;

  return (
    <div className='modal-notificaciones' ref={dropdownRef}>
      <button className='notificaciones' onClick={toggleDropdown}>
        <img src="/images/notificacion.svg" alt="Icono Notificaciones" />
        {
          totalNotificaciones > 0 && (
            <div className='num-notificacion'>{totalNotificaciones}</div>
          )
        }
      </button>
      {isDropdownOpen && (
        <div className="dropdown-notificaciones">
          {isLoading ? (
            <div className="grid-notificaciones">
              <div className="cabecera-notificaciones">
                <h3>Notificaciones</h3>
                <button className='refresh-button' onClick={() => fetchNotificaciones()}>
                  <img src="/images/refresh.svg" alt="Refrescar" />
                </button>
              </div>
              <ContentLoader height={400} width="100%">
                <rect x="0" y="10" rx="4" ry="4" width="100%" height="10" />
                <rect x="0" y="30" rx="4" ry="4" width="100%" height="10" />
                <rect x="0" y="60" rx="4" ry="4" width="100%" height="10" />
                <rect x="0" y="80" rx="4" ry="4" width="100%" height="10" />
                <rect x="0" y="110" rx="4" ry="4" width="100%" height="10" />
                <rect x="0" y="130" rx="4" ry="4" width="100%" height="10" />
              </ContentLoader>
            </div>
          ) : error ? (
            <div className="grid-notificaciones">
              <p className="error-notificaciones">{error}</p>
            </div>
          ) : (
            <div className='grid-notificaciones'>
              <div className="cabecera-notificaciones">
                <h3>Notificaciones</h3>
                <div className="botones-cabecera">
                  {notificacionesPersonalizadas.length > 0 && (
                    <button 
                      className='boton-marcar-todas' 
                      onClick={marcarTodasComoLeidas}
                      title="Marcar todas como leídas"
                    >
                      Marcar todo como leído
                    </button>
                  )}
                  <button className='refresh-button' onClick={() => fetchNotificaciones()}>
                    <img src="/images/refresh.svg" alt="Refrescar" />
                  </button>
                </div>
              </div>

              {/* Notificaciones personalizadas */}
              {notificacionesPersonalizadas.length > 0 && (
                <div className="seccion-notificaciones">
                  {notificacionesPersonalizadas.map((notif) => (
                    <div 
                      key={notif.id}
                      className="notificacion notificacion-personalizada"
                      onClick={() => manejarClickNotificacion(notif)}
                      style={{ cursor: notif.link ? 'pointer' : 'default' }}
                    >
                      <div className="icono-notificacion">
                        <img src={obtenerIconoNotificacion(notif.tipo, notif.icono)} alt={notif.tipo} />
                      </div>
                      <div className="contenido-notificacion">
                        <div className="header-notificacion-contenido">
                          <p className='not-titulo'><b>{notif.titulo}</b></p>
                          <span className={`badge-prioridad ${obtenerClasePrioridad(notif.prioridad)}`}>
                            {obtenerTextoPrioridad(notif.prioridad)}
                          </span>
                        </div>
                        <p className='not-mensaje'>{notif.mensaje}</p>
                        <p className='not-fecha'>
                          {new Intl.DateTimeFormat('es-ES', {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                          }).format(new Date(notif.createdAt))}
                        </p>
                      </div>
                      <button 
                        className="boton-marcar-leida"
                        onClick={(e) => {
                          e.stopPropagation();
                          marcarComoLeida(notif.id);
                        }}
                        title="Marcar como leída"
                      >
                        ✓
                      </button>
                    </div>
                  ))}
                </div>
              )}

              {/* Notificaciones de tickets */}
              {notificacionesTickets.length > 0 && (
                <div className="seccion-notificaciones">
                  {notificacionesTickets.map((ticket, index) => (
                    <Link 
                      to={`/ticket/${ticket.identificador}`} 
                      className='notificacion notificacion-ticket' 
                      key={index}
                      onClick={() => setIsDropdownOpen(false)}
                    >
                      <div className="icono-notificacion">
                        <img src="/images/ticket-noti.svg" alt="Ticket" />
                      </div>
                      <div className="contenido-notificacion">
                        <p className='not-id'><b>#{ticket.identificador}</b> - {ticket.asunto}</p>
                        <p className='not-mensaje'>{ticket.nombre} respondió al ticket.</p>
                        <p className='not-fecha'>
                          {new Intl.DateTimeFormat('es-ES', {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                          }).format(new Date(ticket.updatedAt))}
                        </p>
                      </div>
                    </Link>
                  ))}
                </div>
              )}

              {/* Sin notificaciones */}
              {totalNotificaciones === 0 && (
                <p className='no-pendiente'>No hay notificaciones nuevas.</p>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Notificaciones;
